import React from 'react';
import { Modal, Form, Input, Radio, Icon, Spin } from 'antd';
import { ReactComponent as GrayedGroupIcon } from '../../images/grayed-group.svg';
import './styles.scss';
import { FormattedMessage } from 'react-intl';
import cw from '../../utils/commonwords';

const AddPeopleToGroupModal = Form.create({ name: 'form_in_modal' })(
  // eslint-disable-next-line
  class extends React.Component {
    add = e => {
      this.props.onCreate(e.target.value);
    };
    
    render() {
      const {
        visible,
        onCancel,
        onCreate,
        form,
        groups,
        onGroupSearch,
        addingPeopleToGroup,
        intl
      } = this.props;

      const radioStyle = {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        color: '#698291'
      };

      const { getFieldDecorator } = form;
      
      return (
        <Modal
          destroyOnClose
          className="addPeopleToGroupModal"
          width={405}
          centered
          maskClosable={true}
          visible={visible}
          title={intl.formatMessage(cw.selectGroup)}
          okText={intl.formatMessage(cw.add)}
          cancelButtonProps={{ type: 'link' }}
          onCancel={onCancel}
          onOk={onCreate}
          okButtonProps={{
            loading: addingPeopleToGroup
          }}
          footer={null}
        >
          {groups.length > 10 && (
            <Input.Search
              placeholder={intl.formatMessage(cw.searchForGroup)}
              autoFocus
              style={{ marginBottom: 25 }}
              onChange={onGroupSearch}
            />
          )}
          <Form layout="vertical">
            <Spin spinning={addingPeopleToGroup} tip={intl.formatMessage(cw['AddingPeopleToGroup'])}>
              <Form.Item className="formWrapper">
                {getFieldDecorator('groupId', {})(
                  <Radio.Group className="radioGroup">
                    {groups.length > 0 ? (
                      <React.Fragment>
                        {groups.map((group, index) => (
                          <Radio
                            data-dfs-people-id={`add-person-to-group-${index}`}
                            onClick={this.add}
                            style={radioStyle}
                            key={group.uuid}
                            value={group.uuid}
                          >
                            <Icon component={GrayedGroupIcon} /> {group.name}
                          </Radio>
                        ))}
                      </React.Fragment>
                    ) : (
                        <div style={{ padding: '0.6rem 0.8rem' }}>
                          <p style={{ textAlign: 'center' }}>
                            <FormattedMessage
                              id="App.Groups.noGroupsFound"
                              defaultMessage={'No groups found!'}
                            />
                          </p>
                        </div>
                      )}
                  </Radio.Group>
                )}
              </Form.Item>
            </Spin>
          </Form>
        </Modal>
      );
    }
  }
);
export default AddPeopleToGroupModal;
